'use strict';

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

module.exports = function requirePromise() {
  if (typeof Promise !== 'function') {
    throw new TypeError('`Promise.allSettled` requires a global `Promise` be available.');
  }
};